<ng-container>
  <div class="flex flex-col px-6 py-1.5">
    <span class="text-lg font-medium pb-6" style="font-family: 'Open Sans';">Check-in Verification</span>
    <div *ngIf="verificationForm.get('customerAssociate') && verificationForm.get('address')" class="flex flex-col">

      <form id="associateForm" class="flex flex-row w-auto space-x-8"
        [formGroup]="getNestedFormGroup('customerAssociate')">
        <div class="flex flex-col w-1/2">
          <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">
            Message Preference</span>
          <mat-form-field appearance="outline" class="text-sm">
            <mat-select formControlName="messagePreferenceId">
              <mat-option
                *ngFor="let messageType of dialogData.serviceAppointmentDropdowns.messageTypes | filterBy: ['id']: [1,2]"
                [value]="messageType.id">
                {{messageType.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col w-1/2">
          <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">Email</span>
          <mat-form-field appearance="outline" class="text-sm">
            <input id="emailAddress" matInput formControlName="emailAddress" class="font-normal"
              style="font-family: 'Open Sans'; color: #444" autocomplete="one-time-code">
            <mat-error *ngIf="formSubmitted && getNestedFormGroup('customerAssociate').get('emailAddress').errors"
              class="text-sm">
              Please enter a valid email address.
            </mat-error>
          </mat-form-field>
        </div>
      </form>

      <div class="flex flex-row w-auto space-x-8">
        <form id="serviceAdvisorField" [formGroup]="getNestedFormGroup('appointment')" class="flex flex-col w-1/2"
          novalidate>
          <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">
            Service Advisor<sup>*</sup>
          </span>
          <mat-form-field appearance="outline" class="text-sm">
            <mat-select formControlName="serviceAdvisorId">
              <mat-option
                *ngFor="let advisor of dialogData.serviceAppointmentDropdowns.serviceAdvisors | filterBy: ['rooftopId']: dialogData.appointment.rooftopId | sortNamesBy: ['lastName']"
                [value]="advisor.embedded.associate.id">
                {{advisor.embedded.associate.lastName ? advisor.embedded.associate.lastName :
                ''}}{{advisor.embedded.associate.lastName && advisor.embedded.associate.firstName ? ', ' : ''}}
                {{advisor.embedded.associate.firstName ? advisor.embedded.associate.firstName : ''}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formSubmitted && getNestedFormGroup('appointment').get('serviceAdvisorId').errors"
              class="text-sm">
              {{getNestedFormGroup('appointment').get('serviceAdvisorId').errors | inputError}}
            </mat-error>
          </mat-form-field>
        </form>

        <form id="addressForm" [formGroup]="getNestedFormGroup('address')" class="flex flex-col w-1/2" novalidate>
          <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">Cell Phone
          </span>
          <mat-form-field appearance="outline" class="text-sm">
            <input id="cellPhoneNumber" matInput formControlName="cellPhoneNumber" class="font-normal"
              style="font-family: 'Open Sans'; color: #444" autocomplete="one-time-code"
              [textMask]="{mask: phoneNumberMask, guide: false}" type="text" inputmode="numeric">
            <mat-error *ngIf="formSubmitted && getNestedFormGroup('address').get('cellPhoneNumber').errors"
              class="text-sm">
              {{getNestedFormGroup('address').get('cellPhoneNumber').errors | inputError}}
            </mat-error>
          </mat-form-field>
        </form>
      </div>

      <form id="appointmentForm" class="flex flex-col w-auto pb-3" [formGroup]="getNestedFormGroup('appointment')">
        <div class="flex flex-row space-x-8">
          <div class="flex flex-col w-1/2">
            <span class="font-medium text-base "
              style="font-family: 'Open Sans'; color: #282828">Odometer<sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <div class="flex flex-row justify-between items-center">
                <input id="odometerIn" matInput formControlName="odometerIn" class="font-normal"
                  [textMask]="{mask: numberMask, guide: false}" style="font-family: 'Open Sans'; color: #444"
                  autocomplete="one-time-code" type="text" inputmode="numeric">
                <img *ngIf="isSaviOdometer" class="pl-2 h-3.5 w-auto" src="assets/savi-icon.png" alt="...">
              </div>
              <!-- <input matInput (click)="highlightText($event)" (keydown)="numbersOnly($event)" type="number"
                pattern="^\d*\.?\d*$" type="number" min="0" max="100" name="oilLife" [(ngModel)]="task.oilLife"
                (change)="inspectionService.onOilLifeChange(task)"> -->
              <mat-error *ngIf="formSubmitted && getNestedFormGroup('appointment').get('odometerIn').errors"
                class="text-sm">
                {{getNestedFormGroup('appointment').get('odometerIn').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex flex-col w-1/2">
            <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">License
              Plate</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="licenseNumber" matInput formControlName="licenseNumber" class="font-normal"
                style="font-family: 'Open Sans'; color: #444" autocomplete="one-time-code">
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row space-x-8">
          <div class="flex flex-col w-1/2">
            <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">Transportation</span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="transportOptionId">
                <mat-option *ngFor="let transportOption of dialogData.serviceAppointmentDropdowns.transportOptions"
                  [value]="transportOption.id">
                  {{transportOption.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/2">
            <span class="font-medium text-base " style="font-family: 'Open Sans'; color: #282828">Service
              Code</span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="serviceCode">
                <mat-option *ngFor="let serviceCode of dialogData.serviceAppointmentDropdowns.serviceCodes"
                  [value]="serviceCode.serviceCode">
                  {{serviceCode.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
      <span class="font-medium text-base pb-2" style="font-family: 'Open Sans'; color: #282828">Override customer's
        message preference
        for this repair order</span>
      <form id="overrideForm" class="flex flex-col w-auto pb-12 space-y-3"
        [formGroup]="getNestedFormGroup('overrideOptions')">
        <div class="flex flex-row space-x-8">
          <div class="flex flex-col w-1/2">

            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="messagePreference" placeholder="Message Preference"
                (selectionChange)="changeContactInfoPlaceholder($event.value, dialogData.serviceAppointmentDropdowns.messageTypes)">
                <mat-option
                  *ngFor="let messageType of dialogData.serviceAppointmentDropdowns.messageTypes | filterBy: ['id']: [1,2]"
                  [value]="messageType.id">
                  {{messageType.description}}
                </mat-option>
              </mat-select>
              <mat-error class="text-sm"
                *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreference').errors">
                A message preference is required to override
              </mat-error>
            </mat-form-field>
          </div>

          <ng-container [ngSwitch]="getNestedFormGroup('overrideOptions').get('messagePreference').value">
            <div class="flex flex-col w-1/2" *ngSwitchCase="1">
              <mat-form-field appearance="outline" class="text-sm">
                <input id="messagePreferenceContactInfo" matInput formControlName="messagePreferenceContactInfo"
                  class="font-normal" style="font-family: 'Open Sans'; color: #444"
                  placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code">
                <mat-error
                  *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors"
                  class="text-sm">
                  {{getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/2" *ngSwitchCase="2">
              <mat-form-field appearance="outline" class="text-sm">
                <input id="messagePreferenceContactInfo" matInput formControlName="messagePreferenceContactInfo"
                  [textMask]="{mask: phoneNumberMask, guide: false}" class="font-normal"
                  style="font-family: 'Open Sans'; color: #444" placeholder="{{contactInfoPlaceholderText}}"
                  autocomplete="one-time-code" type="text" inputmode="numeric">
                <mat-error
                  *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors"
                  class="text-sm">
                  {{getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/2" *ngSwitchCase="3">
              <mat-form-field appearance="outline" class="text-sm">
                <input id="messagePreferenceContactInfo" matInput formControlName="messagePreferenceContactInfo"
                  [textMask]="{mask: phoneNumberMask, guide: false}" class="font-normal"
                  style="font-family: 'Open Sans'; color: #444" placeholder="{{contactInfoPlaceholderText}}"
                  autocomplete="one-time-code" type="text" inputmode="numeric">
                <mat-error
                  *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors"
                  class="text-sm">
                  {{getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/2" *ngSwitchCase="4">
              <mat-form-field appearance="outline" class="text-sm">
                <input id="messagePreferenceContactInfo" matInput formControlName="messagePreferenceContactInfo"
                  class="font-normal" style="font-family: 'Open Sans'; color: #444"
                  placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code">
                <mat-error
                  *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors"
                  class="text-sm">
                  {{getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/2" *ngSwitchDefault>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="messagePreferenceContactInfo" matInput formControlName="messagePreferenceContactInfo"
                  class="font-normal" style="font-family: 'Open Sans'; color: #444"
                  placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code">
                <mat-error
                  *ngIf="formSubmitted && getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors"
                  class="text-sm">
                  {{getNestedFormGroup('overrideOptions').get('messagePreferenceContactInfo').errors | inputError}}
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div class="flex flex-row">
          <span class="font-medium text-base pr-2" style="font-family: 'Open Sans'; color: #282828">Exclude
            Communicator
            Messaging</span>
          <mat-slide-toggle matInput labelPosition="before" formControlName="excludeCommunicator"></mat-slide-toggle>
        </div>
      </form>

    </div>
    <div class="flex flex-row place-content-between items-center">
      <span class="font-medium text-sm text-grey-700 cursor-pointer" style="font-family: 'Open Sans'"
        (click)="skipVerifyCustomer()">Skip</span>
      <button id="confirmButton" class="flex place-items-center place-content-center p-2.5 rounded-md" [ngStyle]="{
      background: 'rgba(0, 84, 166, 1)',
      cursor: 'pointer'}" style="font-family: 'Open Sans'; width: 110px; height: 34px" type="submit"
        (click)="verifyCustomer(verificationForm.getRawValue())">
        <span class="text-white font-medium text-sm">Confirm</span>
      </button>
    </div>
  </div>
</ng-container>
